/* unplugin-vue-components disabled */import { render } from "./audioItem.vue?vue&type=template&id=6bea54fd&scoped=true"
import script from "./audioItem.vue?vue&type=script&lang=js"
export * from "./audioItem.vue?vue&type=script&lang=js"

import "./audioItem.vue?vue&type=style&index=0&id=6bea54fd&scoped=true&lang=scss"
import "./audioItem.vue?vue&type=style&index=1&id=6bea54fd&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bea54fd"]])

export default __exports__